"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  iconButton: {
    color: "inherit"
  },
  icon: {
    fontSize: "18px",
    "& + $label": {
      marginLeft: theme.spacing(.5)
    }
  },
  button: {
    padding: theme.spacing(1),
    borderRadius: 0,
    minWidth: 0
  },
  label: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "12px",
    fontWeight: "bold",
    lineHeight: "1",
    textTransform: "uppercase"
  }
}));

const ButtonAction = (_ref) => {
  let name = _ref.name,
      value = _ref.value,
      icon = _ref.icon,
      label = _ref.label,
      options = _ref.options,
      disabled = _ref.disabled,
      color = _ref.color,
      onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "value", "icon", "label", "options", "disabled", "color", "onClick"]);

  const classes = useStyles();

  if (icon && label) {
    return _react.default.createElement(_Button.default, {
      className: classes.button,
      name: name,
      value: value,
      disabled: disabled,
      color: color,
      onClick: onClick
    }, _react.default.createElement(_Icon.default, {
      className: classes.icon
    }, icon), _react.default.createElement("b", {
      className: classes.label
    }, label));
  }

  if (icon) {
    return _react.default.createElement(_IconButton.default, {
      className: classes.iconButton,
      name: name,
      value: value,
      disabled: disabled,
      color: color,
      onClick: onClick
    }, _react.default.createElement(_Icon.default, {
      className: classes.icon
    }, icon));
  }

  return _react.default.createElement(_Button.default, {
    className: classes.button,
    name: name,
    value: value,
    disabled: disabled,
    color: color,
    onClick: onClick
  }, _react.default.createElement("b", {
    className: classes.label
  }, label));
};

var _default = ButtonAction;
exports.default = _default;
module.exports = exports.default;